






















































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DeleteResultModel, TimeEntryViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stTimeEntryApi } from '@/services/st-api';
import { TimeEntryStore } from '@/store/time-entry-store';
import { notifyDeletion, notifySuccess } from '@/utlitities/notifications';

@Component({
  components: {},
})
export default class PauseEntry extends Vue {
  @Prop() entry: TimeEntryViewModel | undefined;
  deleteLoading: boolean = false;

  editPause() {
    this.$router.push({ name: 'PauseEdit', params: { id: this.entry!.id!.toString() } });
  }

  async undoDeletion(id: number) {
    await stTimeEntryApi.undelete(id);

    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);

    notifySuccess('Pause wiederhergestellt.');
  }

  async deleteItem(id: number): Promise<DeleteResultModel> {
    try {
      this.deleteLoading = true;
      const resp = await stTimeEntryApi.delete(id, true);

      await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);

      notifyDeletion(async () => this.undoDeletion(id));

      return resp;
    } finally {
      this.deleteLoading = false;
    }
  }
}
